import React from 'react'

export const ClassificationContext = React.createContext({
    classifications: [],
    steps: [],
    setClassifications: () => {},
    setSteps: () => {},
})
